import { Saveable } from './saveable';

/**
 * Factory methods for quickly creating common types of Saveable states
 */
export namespace SaveableFactory {
  /**
   * Create a Saveable mask without tracking or error states
   * @return {Saveable} A Saveable representing the reset state.
   */
  export function reset(): Saveable {
    return {
      deletionError: undefined,
      isDeleting: undefined,
      isSaving: undefined,
      savingError: undefined,
    };
  }

  /**
   * Create a Saveable mask representing a Saveable in process of saving
   * @return {Saveable} A Saveable representing saving data.
   */
  export function saving(): Saveable {
    return Object.assign(reset(), {
      isSaving: true,
    });
  }

  /**
   * Create a Saveable mask representing an error whilst saving
   * @return {Saveable} A Saveable representing lan error whilst saving
   */
  export function errorSaving(error: any): Saveable {
    return Object.assign(reset(), {
      savingError: error,
    });
  }

  /**
   * Create a Saveable mask representing a Saveable in process of deleting
   * @return {Saveable} A Saveable representing deleting data.
   */
  export function deleting(): Saveable {
    return Object.assign(reset(), {
      isDeleting: true,
    });
  }

  /**
   * Create a Saveable mask representing an error whilst deleting
   * @return {Saveable} A Saveable representing an error whilst deleting
   */
  export function errorDeleting(error: any): Saveable {
    return Object.assign(reset(), {
      deletionError: error,
    });
  }
}
